/* eslint-disable react/no-multi-comp */

import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import styled from 'react-emotion'
import { space } from 'styled-system'
import Link from 'redux-first-router-link'

import {
  selectCurrentSearchQueryString,
  selectCurrentSortOrder,
} from 'selectors/app'

import themeVars from 'ui_theme/site/globals/site.variables'
import { Dropdown, theme, themePropTypes, SVGIcon, Label } from 'shared/ui'

import { propFunc } from 'util/functions'
import { buildSearchPathFromId } from 'util/search'
import { byNewest, byOldest } from 'util/search/sorting'
import TooltipFix from 'components/TooltipFix'

const IconWithTooltip = React.memo(({ className }) => {
  return (
    <TooltipFix
      key="star-icon"
      className={className}
      tooltip="Sorting"
      css={{ top: '-1px' }}
    >
      <SVGIcon name="sort" color="ultraLight" size={14} />
    </TooltipFix>
  )
})

const LabelButton = ({ sortOrder }) => (
  <Label size="small">{`Sort by: ${sortOrder}`}</Label>
)

const buildOptions = (sortOrder, query) => {
  return [
    {
      active: byNewest(sortOrder),
      as: Link,
      key: 'newest',
      text: 'Newest',
      to: buildSearchPathFromId({ sortOrder: 'newest' })(query),
      value: 'newest',
    },
    {
      active: byOldest(sortOrder),
      as: Link,
      key: 'oldest',
      text: 'Oldest',
      to: buildSearchPathFromId({ sortOrder: 'oldest' })(query),
      value: 'oldest',
    },
  ]
}

class SortMenu extends React.PureComponent {
  state = { isOpen: false }

  open = () => {
    this.setState({ isOpen: true })
  }

  close = () => {
    this.setState({ isOpen: false })
  }

  render() {
    const { className, sortOrder, query, displayAsLabel } = this.props
    const { isOpen } = this.state
    const trigger = displayAsLabel ? (
      <LabelButton sortOrder={sortOrder} />
    ) : (
      <IconWithTooltip />
    )
    if (!isOpen) {
      return (
        <div className={className} onClick={this.open}>
          {trigger}
        </div>
      )
    }
    return (
      <Dropdown
        className={className}
        direction="left"
        header="Sorting"
        open
        onClose={this.close}
        icon={null}
        options={propFunc(buildOptions, sortOrder, query)()}
        trigger={trigger}
      />
    )
  }
}

SortMenu.propTypes = {
  /* Current sorting order */
  sortOrder: PropTypes.oneOf(['newest', 'oldest']).isRequired,

  /* Current search query string (aka Query Id) */
  query: PropTypes.string.isRequired,

  /* Theme */
  theme: themePropTypes.theme.isRequired,

  /* Margin/Padding */
  ...themePropTypes.spacing,

  /* Display */
  displayAsLabel: PropTypes.bool,
}

SortMenu.defaultProps = {
  theme,
  displayAsLabel: false,
}

SortMenu.displayName = 'SortMenu'

const Styled = styled(SortMenu)`
  &&& {
    &.active > .Icon-swap-vert {
      color: ${themeVars.groovy};
    }

    .Icon-swap-vert {
      color: ${themeVars.dust};
      font-size: 16px;
    }
    .Icon-swap-vert:hover {
      color: ${themeVars.groovy};
    }

    ${space};
  }
`

const select = state => ({
  sortOrder: selectCurrentSortOrder(state),
  query: selectCurrentSearchQueryString(state),
})

export default connect(select)(Styled)
